import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/edu/clazz/list", params, successCallback, failCallback, exceptionCallback);
	},list3: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/edu/clazz/list3", params, successCallback, failCallback, exceptionCallback);
	},listNoEnd: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/edu/clazz/listNoEnd", params, successCallback, failCallback, exceptionCallback);
	},
	student2: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/edu/clazz/student2", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/edu/clazz/save", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/edu/clazz/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/edu/clazz/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/edu/clazz/remove", params, successCallback, failCallback, exceptionCallback);
	},
	//根据班级名字模糊查询
	fuzzyQuery: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/edu/clazz/fuzzyQuery", params, successCallback, failCallback, exceptionCallback);
	},
	selectList: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/edu/clazz/selectList", params, successCallback, failCallback, exceptionCallback);
	},classPwd: (params, successCallback, failCallback, exceptionCallback) => {
		//根据班级id查询班级默认密码
		ApiUtils.getLoadingAjax(constant.serverUrl + "/edu/clazz/classPwd", params, successCallback, failCallback, exceptionCallback);
	},
	
}

export default api;
